import React from 'react'

export default function HistorialReviewShell({
  cargaHistorialModo, setCargaHistorialModo,
  rows, setRows, rawRows, setRawRows, setCalculoReady,
  reviewTab, setReviewTab, reviewMode, setReviewMode,
  resumenHistorialLaboralRows, modoHerramienta,
}) {
  return (
    <div className="mt-3 rounded-xl border border-white/20 bg-slate-900/50 p-3">
      <p className="text-xs uppercase tracking-wide text-slate-300">Revision de historial laboral</p>
      <p className="mt-1 text-xs text-slate-300">Agrupado por año (descendente). Expandi para revisar y editar campo por campo.</p>
      {cargaHistorialModo === 'pdf' && (
        <div className="mt-2 flex flex-wrap gap-2">
          <button type="button" onClick={() => { setRows([]); setRawRows([]); setCalculoReady(false); setCargaHistorialModo('pdf'); }} className="rounded-lg border border-white/25 bg-white/10 px-3 py-1.5 text-xs font-semibold text-white">Cargar otro PDF</button>
        </div>
      )}
      <div className="mt-2 flex flex-wrap items-center gap-2">
        {[
          { key: 'edicion', label: 'Edicion' },
          ...(modoHerramienta === 'avanzado' ? [{ key: 'procesamiento', label: 'Informacion de carga y control' }] : []),
        ].map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setReviewTab(t.key)}
            className={`rounded-lg px-3 py-1 text-xs font-semibold ${reviewTab === t.key ? 'panel-profile-accent text-profile-accent' : 'panel-profile'}`}
          >
            {t.label}
          </button>
        ))}
        <div className="ml-auto flex items-center gap-2 text-xs">
          <span className="text-slate-300">Vista:</span>
          <button type="button" onClick={() => setReviewMode('simple')} className={`rounded px-2 py-1 ${reviewMode === 'simple' ? 'panel-profile-ok text-profile-ok' : 'panel-profile'}`}>Simple</button>
          <button type="button" onClick={() => setReviewMode('perito')} className={`rounded px-2 py-1 ${reviewMode === 'perito' ? 'panel-profile-warn text-profile-warn' : 'panel-profile'}`}>Perito</button>
        </div>
      </div>
      <div className="mt-3 rounded-lg border border-white/15 bg-slate-900/45 p-3 text-xs text-slate-100">
        <p className="font-semibold text-profile-accent">Resumen historial laboral</p>
        {resumenHistorialLaboralRows.length === 0 ? (
          <p className="mt-1 text-slate-300">No se detectaron filas de resumen de historial laboral en esta carga.</p>
        ) : (
          <>
            <p className="mt-1 text-slate-300">Se recuperaron {resumenHistorialLaboralRows.length} filas desde el PDF de origen.</p>
            <div className="mt-2 overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead>
                  <tr className="text-left text-slate-300">
                    <th className="px-2 py-1">Razon social</th>
                    <th className="px-2 py-1">Identificador</th>
                    <th className="px-2 py-1">Tipo</th>
                    <th className="px-2 py-1">Desde</th>
                    <th className="px-2 py-1">Hasta</th>
                  </tr>
                </thead>
                <tbody>
                  {resumenHistorialLaboralRows.map((r) => (
                    <tr key={r.key} className="border-t border-white/10">
                      <td className="px-2 py-1">{r.razonSocial}</td>
                      <td className="px-2 py-1">{r.identificador || 'SIN_ID'}</td>
                      <td className="px-2 py-1">{r.tipoId}</td>
                      <td className="px-2 py-1">{r.desde}</td>
                      <td className="px-2 py-1">{r.hasta}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
